
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/notificationtemplate",
      function () {
        return require("private-next-pages/notificationtemplate/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/notificationtemplate"])
      });
    }
  